import { Injectable } from '@angular/core';
import { getCurrencySymbol } from '@angular/common';
import * as countryToCurrency from 'country-to-currency';

@Injectable({
  providedIn: 'root'
})
export class CurrencySymbolService {

  currencySymbol(countryCode: string) {
    return getCurrencySymbol(countryToCurrency[countryCode], 'wide');
  }
}
